import React, { FC, useEffect, useState } from "react"
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"

import { SelfServiceTryItNowBeaconHintQueryQuery } from "@graphqlTypes"

import "./SelfServiceTryItNowBeaconHint.scss"
import { isClientSide } from "@utils"

const SelfServiceTryItNowBeaconHint: FC = () => {
  const {
    tryItNowImage,
  } = useStaticQuery<SelfServiceTryItNowBeaconHintQueryQuery>(graphql`
    query SelfServiceTryItNowBeaconHintQuery {
      tryItNowImage: contentfulAsset(contentful_id:{eq:"6HjpPfYTeSl4kKJeVhuwhB"}) {
        imgixImage {
          gatsbyImageData(width: 163)
        }
      }
    }  
  `)

  const [isVisible, setIsVisible] = useState<boolean>(false)

  useEffect(() => {
    if (!isClientSide()) return

    const targetNode = document.querySelector("body")
    const observerConfig = { childList: true }

    if (!targetNode) return

    const onObserved = (mutationList, observer) => {
      let _isVisible = false

      mutationList.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.id === "beacon-container") _isVisible = true
        })
      })

      if (_isVisible) {
        setIsVisible(_isVisible)
        observer.disconnect()

        window.Beacon("once", "open", () => {
          setIsVisible(false)
        })
      }
    }

    const observer = new MutationObserver(onObserved)

    observer.observe(targetNode,observerConfig)

    return () => {
      if (observer) observer.disconnect()
    }
  }, [])

  return tryItNowImage?.imgixImage?.gatsbyImageData ? (
    <GatsbyImage
      alt="Try it now!"
      className={`SelfServiceTryItNowBeaconHint${isVisible ? " is-visible" : ""}`}
      image={tryItNowImage.imgixImage.gatsbyImageData}
    />
  ) : null
}

export default SelfServiceTryItNowBeaconHint